import React from "react";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextBox from './Components/TextBox.jsx';
import { UserProvider } from '../Providers/UserProvider';
import { BaseProvider } from '../Providers/BaseProvider';
import { Routes } from '../Core/Constants';

const LoginForm = ({ onSuccess }) => {
	let T = window.Texts.login;

	let initValues = {
		username: '',
		password: '',
		rememberMe: false
	};
	let validationSchema = Yup.object({
		username: Yup.string()
			.required(T.required),
		password: Yup.string()
			.required(T.required),
		rememberMe: Yup.boolean()
	});

	let submit = (values, actions) => {
		UserProvider.signIn(values, (data) => {
			actions.setSubmitting(false);
			onSuccess(false);
		},
			(error) => {
				BaseProvider.applyServerFormValidation(actions, error);				
			});
	};

	return (
		<Formik initialValues={initValues} validationSchema={validationSchema} onSubmit={(values,  actions ) => submit(values, actions)} >
			{props => (
				<Form autoComplete="off">
					{props.errors.general ?
						<div>
							<p className="missing-entry">
								<strong>{props.errors.general}</strong>
							</p>
						</div> : null}
					<div>
						<div className="form-group">
							<TextBox type="text" name="username" required="true" label={T.username} placeholder={T.username + ':'} />
						</div>
						<div className="form-group">
							<TextBox type="password" name="password" required="true" label={T.password} placeholder={T.password + ':'} />
						</div>
						<div className=".">
							<a href={Routes.LostPassword}>{T.forbiddenPassword}</a>
							<button type="submit" className="btn btn50 iconed icon-continue"><span>{T.loginBtn}</span></button>
						</div>
					</div>
				</Form>
			)}
		</Formik>);
};
export default LoginForm;
